import React, { Fragment } from 'react';
import { useListCashRegistersQuery } from '../../../redux/api/marktApi';
import CashRegister from './CashRegister';

const CashRegisterOverview = () => {
  const { data: cashRegisters, isLoading } = useListCashRegistersQuery();

  return isLoading ? (
    <p>Kassen werden geladen...</p>
  ) : cashRegisters ? (
    <Fragment>
      <h4>Kassen Übersicht</h4>
      <div className='row row-cols-1 row-cols-md-3 g-4 mt-2'>
        {cashRegisters.map((cR) => (
          <CashRegister key={cR.id} cashRegister={cR} />
        ))}
      </div>
    </Fragment>
  ) : (
    <p>Keine Kassen vorhanden.</p>
  );
};

export default CashRegisterOverview;
